import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { IvcfActionTypes } from './ivcf.actions';
import { initialState } from './ivcf.reducer';

const KEY = 'MEDLOGIC_IVCF_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [
  IvcfActionTypes.LoadIvcf
];

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialState);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
